import React, { useState, useEffect, useContext } from 'react';
import { LoyaltyDrawerContainer } from '@thd-olt-component-react/loyalty-benefits';
import { RewardsAndOffersContext, DrawerContext, InfoRewardsContext, InfoPerksContext, InfoOffersContext, ChallengesContext, } from '../contexts';
import { RewardsHubContainer } from '../containers';
import { PageGrid, PageContainer, PageErrorRedirector, PageProviders, } from '../components/shared/page-layout';
import { getFromUrlParams } from '../components/Utils';
import { useIsMobile } from '../hooks';
import { ERR_GENERIC, B2B_BREADCRUMBS } from '../constants';
import { DrawerContainer } from '../components/RewardsHub/Drawer/DrawerContainer';
import { logNewRelicAction, newrelic, REWARDS_HUB_PAGE_LOAD, REWARDS_HUB_PERK_DEEP_LINK, REWARDS_HUB_OFFER_DEEP_LINK, REWARDS_HUB_CHALLENGE_DEEP_LINK, } from '../utils/newrelic';
import { SweepstakesDemoContainer } from '../containers/RewardsHub/SweepstakesDemoContainer';
var RenderPage = function (_a) {
    var customerRole = _a.customerRole;
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useIsMobile(), isMobile = _c.isMobile, isConsumerApp = _c.isConsumerApp;
    var _d = React.useContext(RewardsAndOffersContext), getRewardsAndOffersData = _d.getRewardsAndOffersData, isLoading = _d.isLoading, setIsLoading = _d.setIsLoading, generalError = _d.generalError, setGeneralError = _d.setGeneralError, rewardsAndOffers = _d.rewardsAndOffers;
    var getPerksInfoPerksData = React.useContext(InfoPerksContext).getPerksInfoPerksData;
    var getPerksInfoOffersData = React.useContext(InfoOffersContext).getPerksInfoOffersData;
    var _e = useContext(DrawerContext), setDrawerOpen = _e.setDrawerOpen, setDrawerType = _e.setDrawerType, setDetails = _e.setDetails;
    var _f = useContext(ChallengesContext), activeChallenges = _f.challenge, isChallengeLoading = _f.isChallengeLoading, hasChallengeError = _f.hasChallengeError;
    var isBlendedRewardsEnabled = useContext(InfoRewardsContext).isBlendedRewardsEnabled;
    var loadingPadding = isLoading ? 'sui-px-4' : '';
    // New Relic tracking for page load - error handling
    useEffect(function () {
        if (error) {
            logNewRelicAction(REWARDS_HUB_PAGE_LOAD, error);
            return;
        }
        newrelic.addPageAction(REWARDS_HUB_PAGE_LOAD, {
            result: 'success',
        });
    }, [error]);
    // New Relic tracking for general errors
    useEffect(function () {
        if (generalError && !rewardsAndOffers && !error) {
            newrelic.addPageAction(REWARDS_HUB_PAGE_LOAD, {
                result: 'error',
                errorMessage: 'failure on the call to /rewardsandoffers',
            });
        }
    }, [rewardsAndOffers, generalError, error]);
    // Call the page load event
    useEffect(function () {
        window.LIFE_CYCLE_EVENT_BUS.trigger('customer-loyalty.loyalty-page-load', {
            breadCrumbLabels: ['account', 'rewards hub'],
            pageType: 'maml: rewards hub',
        });
    }, []);
    useEffect(function () {
        var apiControllerRAO = new AbortController();
        var apiControllerPerks = new AbortController();
        var apiControllerOffers = new AbortController();
        Promise.all([
            getRewardsAndOffersData({ signal: apiControllerRAO.signal }),
            getPerksInfoPerksData({ signal: apiControllerPerks.signal }),
            getPerksInfoOffersData({ signal: apiControllerOffers.signal }),
        ])
            .then(function () {
            setIsLoading(false);
        })
            .catch(function (err) {
            setIsLoading(false);
            setGeneralError(ERR_GENERIC);
            setError(err);
        });
        return function () {
            apiControllerRAO.abort();
            apiControllerPerks.abort();
            apiControllerOffers.abort();
        };
    }, []);
    useEffect(function () {
        var handledRef = RenderPage
            ._challengeDeepLinkRef || { current: false };
        RenderPage._challengeDeepLinkRef = handledRef;
        if (handledRef.current)
            return;
        if (!isLoading) {
            var drawerParam = getFromUrlParams('drawerList', false);
            if (drawerParam === 'offer') {
                if (isBlendedRewardsEnabled) {
                    setDrawerType('RewardsList');
                }
                else {
                    newrelic.addPageAction(REWARDS_HUB_OFFER_DEEP_LINK, {
                        result: 'success',
                    });
                    setDrawerType('OffersList');
                }
                setDrawerOpen(true);
            }
            else if (drawerParam === 'perk') {
                if (isBlendedRewardsEnabled) {
                    setDrawerType('RewardsList');
                }
                else {
                    newrelic.addPageAction(REWARDS_HUB_PERK_DEEP_LINK, {
                        result: 'success',
                    });
                    setDrawerType('PerksList');
                }
                setDrawerOpen(true);
            }
            else if (drawerParam === 'challenge') {
                newrelic.addPageAction(REWARDS_HUB_CHALLENGE_DEEP_LINK, {
                    result: 'success',
                });
                if (isChallengeLoading)
                    return;
                handledRef.current = true;
                if (!hasChallengeError ||
                    (Array.isArray(activeChallenges) && activeChallenges.length > 0)) {
                    // Pass the first active challenge
                    setDetails(activeChallenges[0]);
                    setDrawerType('ChallengeDetails');
                    setDrawerOpen(true);
                }
                else {
                    setDrawerType('OffersList');
                    setDrawerOpen(true);
                }
            }
        }
    }, [
        isLoading,
        isChallengeLoading,
        activeChallenges,
        hasChallengeError,
        isBlendedRewardsEnabled,
        setDrawerType,
        setDrawerOpen,
        setDetails,
    ]);
    var RenderRewardsHubPage = function () { return (React.createElement(PageGrid, null,
        React.createElement(PageContainer, { title: "Rewards Hub", breadcrumbs: B2B_BREADCRUMBS.rewardsHub, internalRoutes: ['/myaccount/proXtraRewards'], generalError: generalError, classes: {
                contentContainer: "rewardsHub_page ".concat(loadingPadding),
            }, suppressNavHeading: isConsumerApp },
            React.createElement(SweepstakesDemoContainer, { isLoading: isLoading },
                React.createElement(RewardsHubContainer, { isMobile: isMobile }))))); };
    return React.createElement(RenderRewardsHubPage, null);
};
export var RewardsHubPage = function (_a) {
    var customerRole = _a.customerRole;
    return (React.createElement(PageErrorRedirector, null,
        React.createElement(PageProviders, { page: "RewardsHubPage" },
            React.createElement(DrawerContainer, null),
            React.createElement(RenderPage, { customerRole: customerRole }),
            React.createElement(LoyaltyDrawerContainer, null))));
};
RewardsHubPage.displayName = 'RewardsHubPage';
